{
  "Envanter": "Envanter",
  "envanter": {
    "Alış Firma": "Alış Firma",
    "Alış Tarih": "Alış Tarih",
    "Alış Tarihi": "Alış Tarihi",
    "Değer": "Değer",
    "Envanter": "Envanter",
    "Envanter Detay": "Envanter Detayı",
    "Hareket": "İşlem",
    "Hareket Notu": "Hareket Notu",
    "Marka": "Marka",
    "Model": "Model",
    "Nitelik": "Nitelik",
    "Serial": "Seri Numarası",
    "Çoklu Giriş": "Çoklu Giriş",
    "ExcelAktar": "Excel'e Aktar",
    "Status": "Statü",
    "Kod": "Kod",
    "Ad": "Ad",
    "Tip": "Tip",
    "Tür": "Tür",
    "Zimmet": "Zimmet",
    "Durum": "Durum",
    "Açıklama": "Açıklama",
    "Aktif Kayıt": "Aktif Kayıt",
    "Pasif Kayıt": "Pasif Kayıt",
    "Sıra": "Sıra",
    "Aktif/Pasif": "Aktif/Pasif",
    "Şube": "Şube",
    "Bilgi Notu": "Bilgi Notu"
  }
}
